import { render, staticRenderFns } from "./client-footer.vue?vue&type=template&id=4307dd0d&scoped=true&lang=pug"
import script from "./client-footer.js?vue&type=script&lang=js&external"
export * from "./client-footer.js?vue&type=script&lang=js&external"
import style0 from "./client-footer.vue?vue&type=style&index=0&id=4307dd0d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4307dd0d",
  null
  
)

export default component.exports